module.exports = __webpack_public_path__ + "img/form-r-2.c77932b4.svg";